import Vue from 'vue'
import VueRouter from 'vue-router';
import { upperFirst } from './helpers'
import Landing from "@/views/Landing";
import ProgramInscription from "@/views/ProgramInscription";
import AcademiaEgresadosInscription from "@/views/AcademiaEgresadosInscription";
import Step1 from "@/views/inscription-steps/Step1";
import Step2 from "@/views/inscription-steps/Step2";
import Step3 from "@/views/inscription-steps/Step3";
import Step4 from "@/views/inscription-steps/Step4";
import ReStep1 from "@/views/course-recommended/Step1";
import ReStep2 from "@/views/course-recommended/Step2";
import ReStep3 from "@/views/course-recommended/Step3";
import ReStep4 from "@/views/course-recommended/Step4";
import CheckInStep1 from "@/views/check-in-steps/CheckInStep1";
// import CheckInStep2 from "@/views/check-in-steps/CheckInStep2";
import SuccessInscription from "@/views/SuccessInscription";
import BuyOtherProgram from "@/views/BuyOtherProgram";
import NotFound from "@/views/404";
import Preloader from "@/components/Preloader";
import componentsTest from "@/views/componentsTest";
import BackpackPageMobile from "@/views/BackpackPageMobile";
import Voucher from "@/views/Voucher";
import Outlet1 from "@/views/outlet-steps/Step1";
import Outlet2 from "@/views/outlet-steps/Step2";
import Outlet3 from "@/views/outlet-steps/Step3";



Vue.use(VueRouter);

const routes = [
    {
        path: '',
        component: Landing,
        name: 'Landing'
    },

    {
        path: '/inscripcion',
        component: ProgramInscription,
        name: 'ProgramInscription'
    },

    {
        path: '/academia-egresados',
        component: AcademiaEgresadosInscription,
        name: 'AcademiaEgresadosInscription'
    },

    {
        path: '/inscripcion-paso-1',
        component: Step1,
        name: 'Step1',
        requireStorageKey: 'selectedProgram;students'
    },

    {
        path: '/inscripcion-paso-2',
        component: Step2,
        name: 'Step2',
        requireStorageKey: 'selectedSubjects;selectedLocation;selectedCourses'
    },

    {
        path: '/inscripcion-paso-3',
        component: Step3,
        name: 'Step3',
        requireStorageKey: 'studentsWithPrices'
    },

    {
        path: '/inscripcion-paso-4',
        component: Step4,
        name: 'Step4',
        requireStorageKey: 'fullOrder'
    },

    {
        path: '/informacion-compra',
        component: CheckInStep1,
        name: 'CheckInStep1'
    },

    {
        path: '/inscripcion-exitosa',
        component: SuccessInscription,
        name: 'SuccessInscription'
    },

    {
        path: '/agregar-otro-alumno',
        component: BuyOtherProgram,
        name: 'BuyOtherProgram'
    },

    {
        path: '/preloader',
        component: Preloader,
        name: 'Preloader'
    },

    {
        path: '/components',
        component: componentsTest,
        name: 'componentsTest'
    },

    {
        path: '/mochila',
        component: BackpackPageMobile,
        name: 'BackpackPageMobile'
    },
    {
        path: '/comprobante/:buyorder',
        component: Voucher,
        name: 'Comprobante Pago'
    },

    {
        path: '/404',
        component: NotFound,
        name: '404'
    },

    /* 404 - always has to be the last one*/
    { path: '*', redirect: { name: '404' } },
    {
        path: '/recomendado-paso-1',
        component: ReStep1,
        name: 'Re-Step1',
        // requireStorageKey : 'selectedProgram;students'
    },
    {
        path: '/recomendado-paso-2',
        component: ReStep2,
        name: 'Re-Step2',
        // requireStorageKey : 'selectedProgram;students'
    },
    {
        path: '/recomendado-paso-3',
        component: ReStep3,
        name: 'Re-Step3',
        // requireStorageKey : 'selectedProgram;students'
    },
    {
        path: '/recomendado-paso-4',
        component: ReStep4,
        name: 'Re-Step4',
        // requireStorageKey : 'selectedProgram;students'
    },
    {
        path: '/packpdv',
        component: Outlet1,
        name: 'Outlet1',
        requireStorageKey: '#'
    },

    {
        path: '/packpdv-2',
        component: Outlet2,
        name: 'Outlet2',
        requireStorageKey: '#'
    },

    {
        path: '/packpdv-3',
        component: Outlet3,
        name: 'Outlet3',
        requireStorageKey: '#'
    },
   
]

const router = new VueRouter({

    mode: 'history',

    routes,

    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})

const protectedStep = [
    ...routes.filter(r => r.name ? r.name.startsWith('Step') : false).map(r => ({
        path: r.path,
        requireStorageKey: r.requireStorageKey ? r.requireStorageKey.split(';') : []
    }))
]
router.beforeEach(async (to, from, next) => {
    document.title = to.path === "/" ? "PDV - Pedro de Valdivia" :
        "PDV - " + to.path.replace('/', '').split('-').map(t => upperFirst(t)).join(" ");
    if (!from.name) { //solo cuando venga desde url
        const currentStep = protectedStep.find(pr => pr.path === to.path);
        if (currentStep) {
            const { requireStorageKey } = currentStep;
            let existKeys = 0;
            //cuenta el total de keys requeridas que se cumplan
            requireStorageKey.forEach(key => {
                if (localStorage.getItem(key)) existKeys++;
            })
            if (existKeys === requireStorageKey.length) {
                next()
            } else {
                //si no estan todas las keys requeridas redirecciona a /
                next('/')
            }
        }
    }
    next()
})

export default router; 